import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

export const useBalanceRefresh = () => {
  const pathname = usePathname();
  const { refreshBalance, isAuthenticated } = useAuth();

  useEffect(() => {
    // Only refresh balance if user is authenticated
    if (isAuthenticated) {
      refreshBalance();
    }
  }, [pathname, isAuthenticated, refreshBalance]);
};
